import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useReturn } from "./useReturn";
import { BiArrowBack } from "react-icons/bi";
import CommonSearch from "../../../SharedFiles/CommonSearch/CommonSearch";
import ReturnModal from "./ReturnModel";
import DynamicTable from "../../../SharedFiles/CommonTable/dynamicTable";
import { useEffect, useMemo, useState } from "react";
import {
  GetReturn,
  PostReturn,
} from "../../../APIServices/ProductionService/Return/returnThunk";
import {
  showDeleteConfirmation,
  showSubmitConfirmation,
} from "../../../SharedFiles/WarningMessage/deleteWarning";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../../SharedFiles/Footer/Footer";
import { HashLoader } from "react-spinners";
import toast, { Toaster } from "react-hot-toast";
import "./Return.css";
import { TextField } from "@mui/material";
const SEARCH_FIELDS = ["Vehicle_Number"];
const TABLE_HEADERS = [
  // "delivery_Number",
  "item_Code",
  "item_Name",
  "Receipt_Type",
  "batch_Number",
  "Quantity",
  "Weight",
  // "Remarks",
  // "Reason",
];

const Return = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    isDialogOpen,
    setIsDialogOpen,
    openManual,
    setOpenManual,
    selectedItem,
    handleValueChange,
    deliveryNo,
    setDeliveryNo,
    setInitialValue,
    setInProgress,
    InProgress,
    tableRows,
    setTableRows,
    formValues,
    initialValue,
    setSelectedItem,
    setFormValues,
    openModal,
    handleSelectDelivery,
    handleSelectValue,
  } = useReturn();
console.log("tableRows",tableRows);

  const [rowIndex, setRowIndex] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [remarks, setRemarks] = useState("");
  const { loading, PostReturnResponse, error, ReturnItems, ReturnList,InvoiceDetail } =
    useSelector((state) => state.ReturnData ?? {});
  const isLoading = () =>
    loading.ReturnList || loading.ReturnItems || loading.InvoiceDetail|| loading.PostReturnResponse;
  console.log("hasInvoiceData",InvoiceDetail);
  const batchChecker = () => {
    // if (InProgress.PostDeliveryCall && PostDeliveryResponse === "Success") {
    if (InProgress.postReturn && PostReturnResponse === "Success") {
      toast.success(t("Submitted successfully"));
      setTableRows([]);
      setFormValues({});
      setDeliveryNo({});
      setSelectedItem({});
      setInitialValue({});
      setInProgress((prev) => ({
        ...prev,
        postReturn: false,
      }));
    }
    if (InProgress.postReturn && error.PostReturnResponseError) {
      setInProgress((prev) => ({
        ...prev,
        postReturn: false,
      }));
      const errormessage = error.PostReturnResponseError.errorMessage;
      toast.error(`${errormessage}`);
    }

    if (InProgress.returnDetails && error.ReturnListError) {
      const errormessage = error.ReturnListError.errorMessage;
      setInProgress({ ...InProgress, returnDetails: false });
      toast.error(errormessage);
      return;
    }
    // if (InProgress.returnItems && error.ReturnItemsError) {
    //   const errorss = error.ReturnItemsError.errorMessage;
    //   const errorCode = error.ReturnItemsError.errorCode;
    //   const hasInvoiceData = Array.isArray(InvoiceDetail) && InvoiceDetail.length > 0;
    //   setInProgress((prev) => ({
    //     ...prev,
    //     returnItems: false,
    //   }));
    //   if (errorCode == 404 && hasInvoiceData) {
    //     return;
    //   }
    //   toast.error(errorss);
    // }

    // if (InProgress.getInvoiceDetail && error.InvoiceDetailError ) {

    //   const hasReturnData = ReturnItems?.length > 0;
    //   const errorss = error.InvoiceDetailError.errorMessage;
    //   const errorCode = error.InvoiceDetailError.errorCode;
    //   if (errorCode == 404 && hasReturnData) {
    //     return;
    //   }
    //   setInProgress((prev) => ({
    //     ...prev,
    //     getInvoiceDetail: false,
    //   }));
    //   toast.error(errorss);
    // }

    if (InProgress.returnItems && error.ReturnItemsError) {
      const errorss = error.ReturnItemsError.errorMessage;
      const errorCode = error.ReturnItemsError.errorCode;
      setInProgress((prev) => ({
        ...prev,
        returnItems: false,
      }));
      if (errorCode === 404) {
        return;
      }
    
      toast.error(errorss);
    }
    
    if (InProgress.getInvoiceDetail && error.InvoiceDetailError) {
      const errorss = error.InvoiceDetailError.errorMessage;
      const errorCode = error.InvoiceDetailError.errorCode;
      setInProgress((prev) => ({
        ...prev,
        getInvoiceDetail: false,
      }));
      if (errorCode === 404 && ReturnItems?.length > 0) {
        return;
      }
    
      toast.error(errorss);
    }
  };
  useEffect(() => {
    batchChecker(); // Call batchChecker every time DisassembleBatch or error changes
  }, [ReturnList, ReturnItems, PostReturnResponse, loading, error, InProgress,InvoiceDetail]);
  const handleAddToTable = (newRow) => {
    const isDuplicateBatch = tableRows.some(
      (row, index) =>
        row.batch_Number === newRow.batch_Number &&
        (!editMode || index !== rowIndex) // allow same row while editing
    );
  
    if (isDuplicateBatch) {
      alert("This batch number already exists.");
      return;
    }
    if (editMode) {
      const updatedRow = [...tableRows];
      updatedRow[rowIndex] = {
        ...newRow,
      };
      setTableRows(updatedRow);
    } else {
      setTableRows((prevData) => [...prevData, newRow]);
    }
    setEditMode(false);
    setRowIndex("");
  };

  const handleAdd = () => {
    setIsDialogOpen(true);
  };

  const handleTableDatasubmit = () => {
    showSubmitConfirmation(() => {
      submitReturnData();
    });
  };

  // const submitReturnData = () => {
  //   const dataToPost =
  //     tableRows.length > 0
  //       ? [
  //           {
  //             customercode: initialValue.customerCode,
  //             vehicleNo: initialValue?.vehicle_No,
  //             wbDocEntry: initialValue.wbDocEntry,
  //             remarks: remarks || "",
  //             returnListData: tableRows.map((item) => ({
  //               itemCode: item?.item_Code || "",
  //               lineNum: item?.lineNum,
  //               deliverNo: item.delivery_Number,
  //               docEntry: item.docEntry,
  //               weight: item?.Weight || 0,
  //               itemName: item?.item_Name || "",
  //               qtyNo: String(item?.Quantity || 0),
  //               batchNo: item?.batch_Number || "",
  //               receiptType: item?.Receipt_Type || "",
              
  //             })),
  //           },
  //         ]
  //       : null;

  //   if (dataToPost) {
  //     setInProgress((prev) => ({
  //       ...prev,
  //       postReturn: true,
  //     }));
  //     dispatch(PostReturn(dataToPost));
  //   }
  // };
  
  const submitReturnData = () => {
    const dataToPost =
      tableRows.length > 0
        ? [
            {
              customercode: initialValue.customerCode,
              vehicleNo: initialValue?.vehicle_Number,
              wbDocEntry: initialValue.wbDocEntry,
              remarks: remarks || "",
              returnListData: tableRows.map((item) => ({
                itemCode: item?.item_Code || "",
                lineNum: item?.lineNum,
                // docNum: item.delivery_Number,
                docEntry: item.docEntry,
                invoiceDocEntry: item?.InvoiceDocEntry,
                weight: item?.Weight || 0,
                itemName: item?.item_Name || "",
                qtyNo: String(item?.Quantity || 0),
                batchNo: item?.batch_Number || "",
                receiptType: item?.Receipt_Type || "",
              
              })),
            },
          ]
        : null;

    if (dataToPost) {
      setInProgress((prev) => ({
        ...prev,
        postReturn: true,
      }));
      dispatch(PostReturn(dataToPost));
    }
  };
  const onEdit = (action, rowIndex, row) => {
    const editIndex = tableRows.findIndex(
      (r) => r.batch_Number === row.batch_Number
    );
    const selectedRow = tableRows[editIndex];
    setRowIndex(editIndex);
    setDeliveryNo({
      delivery_Number: selectedRow?.delivery_Number,
      docEntry: selectedRow?.docEntry,
    });

    setFormValues(selectedRow);
    setEditMode(true);
    setIsDialogOpen(true);
  };
  const onDelete = (action, rowIndex, row) => {
    const deleteIndex = tableRows.findIndex(
      (r) => r.batch_Number === row.batch_Number
    );

    showDeleteConfirmation(() => {
      const updatedTableBody = tableRows.filter(
        (_, index) => index !== deleteIndex
      );
      setTableRows(updatedTableBody);
    });
  };

  const groupedDataSorted = useMemo(() => {
    const grouped =
      tableRows?.reduce((acc, row) => {
        const key = row.delivery_Number;
        if (!acc[key]) acc[key] = [];
        acc[key].push(row);
        return acc;
      }, {}) || {};
    const entries = Object.entries(grouped);
    return entries;
  }, [tableRows]);

  return (
    <>
      <div className="container mainDiv">
        {/* Header */}
        <div className="header d-flex align-items-center justify-content-between mb-3">
          <button onClick={() => navigate(-1)} className="goBackButton">
            <BiArrowBack size={24} />
          </button>
          <p className="m-0 fw-medium mx-3">{t("RETURN / AR-CREDIT MEMO")}</p>
        </div>

        {/* Search */}
        <CommonSearch
          inputFields={SEARCH_FIELDS}
          data={ReturnList}
          values={selectedItem}
          setValues={setSelectedItem}
          handleDropdownClick={openModal}
        />

        {/* Modal */}
        <ReturnModal
          openManual={openManual}
          TABLE_HEADERS={TABLE_HEADERS}
          deliveryNo={deliveryNo}
          setDeliveryNo={setDeliveryNo}
          setEditMode={setEditMode}
          setOpenManual={setOpenManual}
          setModelOpen={setIsDialogOpen}
          selectedItem={selectedItem}
          initialValue={initialValue}
          modelOpen={isDialogOpen}
          editMode={editMode}
          formValues={formValues}
          handleValueChange={handleValueChange}
          setFormValues={setFormValues}
          handleSelectDelivery={handleSelectDelivery}
          handleSelectValue={handleSelectValue}
          onAdd={handleAddToTable}
          // setSelectedValues={setSelectedValues}
        />
        {tableRows.length > 0 && (
          <>
            {/* Table Header with Add Button */}
            <div className="d-flex justify-content-end align-items-center mb-2">
              <button className="button xs" onClick={handleAdd}>
                {t("Add Item")}
              </button>
            </div>
            {/* Table */}
            <DynamicTable
              header={TABLE_HEADERS}
              tablebody={tableRows}
              onEdit={onEdit}
              onDelete={onDelete}
              pageName={"Return"}
              groupedDataSorted={groupedDataSorted}
            />
            <TextField
              value={remarks || ""} // Use "Remarks" as key
              onChange={(e) => {
                // directly update formValues object
                setRemarks(e.target.value); // Fixed syntax here
              }}
              variant="outlined"
              label="Remarks"
              placeholder="Enter Remarks"
              style={{ width: "100%", marginTop: "10px" }}
              multiline // allows multiple lines
              rows={3} // height of the text area
            />

            {/* Submit Button Right-Aligned */}
            {tableRows.length > 0 && (
              <div className="button-container">
                <button className="button xs" onClick={handleTableDatasubmit}>
                  {t("Submit")}
                </button>
              </div>
            )}
          </>
        )}

        {/* Loader */}

        {/* Toaster */}
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              fontSize: "16px",
              padding: "16px",
              width: "400px",
              borderRadius: "8px",
            },
          }}
        />

        {/* Footer */}
      </div>
      {isLoading() && (
        <div className="loader">
          <HashLoader color="#ed1c24" />
        </div>
      )}

      <Footer />
    </>
  );
};

export default Return;
